import { IJobResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';
import { Modify } from 'utils/types';

const defaultLocationsSort: DataSourceSort[] = [{ field: 'EnqueuedTime', dir: 'desc' }];

export type JobsFilter = Readonly<{
    corporationId?: string;
    locationId?: string;
    nameSearch: string | undefined;
}>;

export type UseJobsDataSourceOptions = Modify<
    BaseDataSourceOptions<IJobResponse, JobsFilter>,
    { defaultSort?: DataSourceSort[] }
>;

export type PagedJobsDataSource = PagedDataSource<IJobResponse, JobsFilter>;

const queryFn: DataSourceQuery<IJobResponse, JobsFilter> = ({
    filter: { nameSearch, corporationId, locationId },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
        locationId ? Filter.eq('LocationId', locationId) : undefined
    );
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getJobs({ filter, page, pageLimit, orderBy, nameSearch })
    );
};

export function usePagedJobsDataSource({
    defaultSort = defaultLocationsSort,
    ...options
}: UseJobsDataSourceOptions): PagedJobsDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: queryFn,
    });
}
